import { useEffect, useState } from 'react';
import { getVuelos, type Vuelo } from '../services/flights';

/**
 * El vuelo de dron más reciente que ya se puede ver.
 *
 * Existe para que la ortofoto sirva de fondo en TODOS los mapas de la
 * plataforma —dashboard, suelo, clima— y no sólo dentro del módulo Mapas.
 * La imagen satelital genérica puede tener años y varios metros por pixel;
 * la del dron es de este mes y tiene centímetros. Sobre esa se entienden
 * mucho mejor los sensores.
 *
 * Devuelve `null` sin ruido cuando el cliente no tiene el módulo activado o
 * todavía no ha subido ningún vuelo: son los dos casos normales, no errores.
 */
export function useOrtofoto(): { vuelo: Vuelo | null; cargado: boolean } {
  const [vuelo, setVuelo] = useState<Vuelo | null>(null);
  const [cargado, setCargado] = useState(false);

  useEffect(() => {
    let cancelado = false;
    getVuelos()
      .then(lista => {
        if (cancelado) return;
        // La lista ya viene de la más reciente a la más vieja; sólo hay que
        // saltarse las que siguen procesándose o fallaron.
        setVuelo(lista.find(v => v.estado === 'listo') ?? null);
      })
      // Un 403 aquí significa "este cliente no tiene el módulo Mapas", que es
      // una respuesta legítima y no algo que reportar. Los mapas siguen
      // funcionando con la imagen satelital de siempre.
      .catch(() => { if (!cancelado) setVuelo(null); })
      .finally(() => { if (!cancelado) setCargado(true); });
    return () => { cancelado = true; };
  }, []);

  return { vuelo, cargado };
}
